import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { CaretDown, CaretUp, Lock, PlusCircle } from '@phosphor-icons/react'

const ToolbarMenu = ({
  routes = [],
  isAnalyticsVisible,
  isBuildingSelected,
  toggleAnalyticsVisibility,
}) => {
  const { t } = useTranslation(['reservations'])
  const location = useLocation()
  const isBookingsRoute = location.pathname.includes('/bookings')
  const navigate = useNavigate()

  if (!routes.length || !routes.some((route) => location.pathname.includes(route.path))) return null

  return (
    <nav className="reservations-toolbar-menu">
      <ul>
        {routes.map(
          ({ name, path, hidden, lock }) =>
            !hidden && (
              <li key={name}>
                <NavLink to={path} className={({ isActive }) => (isActive ? 'is-active' : '')}>
                  <span>
                    {lock && <Lock size={18} className="reservations-nav-item-lock-icon" />} {name}
                  </span>
                </NavLink>
              </li>
            ),
        )}
      </ul>
      {isBookingsRoute ? (
        <button
          className="button button-transparent"
          onClick={toggleAnalyticsVisibility}
          disabled={!isBuildingSelected}
        >
          {isAnalyticsVisible ? <CaretUp /> : <CaretDown />}
          {isAnalyticsVisible
            ? t('reservations:toolbarMenu.hideAnalytics')
            : t('reservations:toolbarMenu.showAnalytics')}
        </button>
      ) : (
        <button
          className="button button-primary"
          onClick={() => navigate('/dashboard/building-dashboard/reservations/amenities/create')}
        >
          <PlusCircle weight="regular" />
          {t('reservations:emptyState.createNewAmenity')}
        </button>
      )}
    </nav>
  )
}

ToolbarMenu.propTypes = {
  routes: PropTypes.array,
  isAnalyticsVisible: PropTypes.bool,
  isBuildingSelected: PropTypes.bool,
  toggleAnalyticsVisibility: PropTypes.func,
}

export default ToolbarMenu
